<template>
  <div class="link-cards d-flex">
    <link-card-item
      :class="[
        'link-card-item flex-1',
        { 'ml-5': index > 0, 'd-none d-lg-block': index > 3 },
      ]"
      v-for="(cardItem, index) in cardItems"
      :key="cardItem.project.name"
      :type="cardItem.type"
      :tags="cardItem.tags"
      :project="cardItem.project"
      :apy="cardItem.apy"
    />
  </div>
</template>
<script>
import LinkCardItem from "./CardItem";
import { mapGetters } from "vuex";
export default {
  components: {
    LinkCardItem,
  },
  computed: {
    ...mapGetters({
      projects: "projectConfig/activeProjects",
      getProjectByName: "projectConfig/getProjectByName",
      stakeApyMap: "productStats/stakeApyMap",
      apys: "productStats/apys",
      allVaults: "projectConfig/allVaults",
    }),
    newProject() {
      const project =
        this.projects.find(item => item.config?.isNew) ||
        this.projects.slice(-1)[0];
      return {
        type: "stake",
        tags: ["new", "proof-of-stake"],
        project: {
          text: project.text,
          description: project.description,
          link: "/stake/" + project.name,
          variesApy: project.variesApy,
        },
        apy: Number(this.stakeApyMap[project.name]?.apy || 0) * 100,
      };
    },
    highestApyVault() {
      return this.allVaults
        .map(item => ({
          type: "vault",
          tags: ["featured", "defi vaults"],
          project: {
            text: item.identity.toUpperCase(),
            description: item.aboutTheVault,
            link: "/vaults/" + item.identity.toLowerCase(),
          },
          apy:
            Number(this.apys.vaults[item.vaultType]?.[item.coin]?.apy || 0) *
            100,
        }))
        .sort((a, b) => b.apy - a.apy)
        .slice(0, 2);
    },
    highestApyStake() {
      const legacyProjects = this.projects.filter(item => item.isLegacy);
      console.log(this.stakeApyMap);
      return Object.keys(this.stakeApyMap)
        .sort((a, b) => this.stakeApyMap[b].apy - this.stakeApyMap[a].apy)
        .filter(item => !legacyProjects.includes(item))
        .map(item => ({
          type: "stake",
          tags: ["featured", "proof-of-stake"],
          project: {
            text: this.getProjectByName(item).text,
            description: this.getProjectByName(item).description,
            link: "/stake/" + this.getProjectByName(item).name,
          },
          apy: this.stakeApyMap[item].apy * 100,
        }))
        .slice(0, 4);
    },
    // blogs() {
    //   return [
    //     {
    //       type: "blog",
    //       tags: ["latest", "blog"],
    //       project: {
    //         text: "Welcome to Unagii 2.0",
    //         description:
    //           "Lorem ipsum dolor sit amet consectetur adipisicing elit. Quis enim natus debitis cupiditate ipsam rem asperiores quas, autem officiis ab. Veritatis eos facere cupiditate cum illum expedita repellendus at magnam!",
    //       },
    //     },
    //     {
    //       type: "blog",
    //       tags: ["featured", "blog"],
    //       project: {
    //         text: "Introductory Guide",
    //         description:
    //           "Lorem ipsum dolor sit amet consectetur adipisicing elit. Quis enim natus debitis cupiditate ipsam rem asperiores quas, autem officiis ab. Veritatis eos facere cupiditate cum illum expedita repellendus at magnam!",
    //       },
    //     },
    //   ];
    // },
    cardItems() {
      return [
        this.newProject,
        ...this.highestApyStake,
        // ...this.blogs,
      ];
    },
  },
};
</script>
